import React from 'react'

import style from './style.module.css'

type Props = {
  id: string
  title?: string
}

function YouTubeVideo({ id, title }: Props) {
  return (
    <div className={style.wrapper}>
      <iframe
        width='355'
        height='194'
        src={`https://www.youtube.com/embed/${id}`}
        title={title}
        frameBorder='0'
      ></iframe>
    </div>
  )
}

export default YouTubeVideo
